import { ComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";
import React from "react";
import {
  LibraryPrivacyBadge,
  privacyTooltip,
} from "../badge/LibraryPrivacyBadge";

interface ComponentTemplatePrivacyBadgeProps {
  template: ComponentTemplateDto;
  size?: number;
  showLabel?: boolean;
}

export function ComponentTemplatePrivacyBadge({
  template,
  size = 40,
  showLabel = true,
}: ComponentTemplatePrivacyBadgeProps) {
  const tooltip = privacyTooltip("component template", template.privacy);

  return (
    <LibraryPrivacyBadge
      privacy={template.privacy}
      owner={
        template.coachInfo
          ? {
              photoUrl: template.coachInfo.coachPhotoUrl,
              displayName: template.coachInfo.coachName,
            }
          : undefined
      }
      tooltip={tooltip}
      size={size}
      showLabel={false}
    />
  );
}
